
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"8","width":"8","height":"1","rx":".5","fill":"#8492A6"}}),_c('rect',{attrs:{"x":"11","y":"8","width":"3","height":"1","rx":".5","fill":"#8492A6"}}),_c('rect',{attrs:{"x":"2","y":"13","width":"3","height":"1","rx":".5","fill":"#8492A6"}}),_c('rect',{attrs:{"x":"2","y":"3","width":"3","height":"1","rx":".5","fill":"#8492A6"}}),_c('rect',{attrs:{"x":"6","y":"13","width":"8","height":"1","rx":".5","fill":"#8492A6"}}),_c('rect',{attrs:{"x":"6","y":"3","width":"8","height":"1","rx":".5","fill":"#8492A6"}}),_c('circle',{attrs:{"cx":"5.5","cy":"13.5","r":"1","stroke":"#8492A6"}}),_c('circle',{attrs:{"cx":"5.5","cy":"3.5","r":"1","stroke":"#8492A6"}}),_c('circle',{attrs:{"cx":"10.5","cy":"8.5","r":"1","stroke":"#8492A6"}})])
          )
        }
      }
    